import { createAction } from '@reduxjs/toolkit';
export const UPDATE_CONTACT = 'UPDATE_CONTACT';
export const updateContactAction = createAction(UPDATE_CONTACT, (payload) => ({
    payload
}));